"use client"

import JobMap from "./JobMap"
import DashboardLayout from "@/views/dashboard/DashboardLayout"

export default function JobMapPage() {
  return (
    <DashboardLayout>
      <JobMap />
    </DashboardLayout>
  )
}
